import React from "react";

import { Button, Stack } from "@chakra-ui/react";
import { Link, LinkProps, useLocation } from "react-router-dom";
import useTranslations from "../../../hooks/useTranslations";

type NavigationTabProps = LinkProps & {
  isActive?: boolean;
};

const NavigationTab: React.FC<NavigationTabProps> = ({
  to,
  children,
  isActive = false,
}) => {
  return (
    <Button
      as={Link}
      to={to}
      variant={isActive ? "solid" : "outline"}
      rounded="3xl"
      fontSize="sm"
      fontWeight="semibold"
      py="2"
      px="6"
      colorScheme={isActive ? "primary" : undefined}
    >
      {children}
    </Button>
  );
};

const NavigationTabs: React.FC = () => {
  const t = useTranslations();
  const { pathname } = useLocation();

  return (
    <Stack direction={{ base: "column", lg: "row" }} spacing="3">
      <NavigationTab to="/login" isActive={pathname === "/login"}>
        {t("forms.actions.connection")}
      </NavigationTab>
      <NavigationTab
        to="/connection-link"
        isActive={pathname === "/connection-link"}
      >
        {t("login.useConnectionLink")}
      </NavigationTab>
    </Stack>
  );
};

export default React.memo(NavigationTabs);
